/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Col, message, Row } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { fetchJSON } from '../../utils'

import Footer from '../../components/Footer'
// import MyFiles from '../../components/MyFiles'
import FooterArchievement from '../../components/Footer/FooterArchievement'
import AboutBlock from '../../components/AboutBlock'
// import SupportedFormatTable from '../../components/SupportedFormatTable'
import { getProductSchemes } from '../../components/Schema/ProductSchema'
import GoogleAdsense from '../../components/Ads/GoogleAdsense'
import getDeviceConfig from '../../hooks/Breakpoint'

import { NextSeo } from 'next-seo'
import { fetchStatistics, fetchUsageInfo, setList } from '../../redux/actions/file_list'
import { setFormats } from '../../redux/actions/formats'
// import { readableBytes } from '../../utils'
import { useCookies } from 'react-cookie'
import Link from 'next/link'

import styles from './format.module.sass'
import Head from 'next/head'
import TopConversions from '../../components/TopConversions'
import HeaderBar from '../../components/HeaderBar'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import getLanguage from '../../utils/i18n'
import ConvertSteps from '../../components/ConvertSteps'
import DescBlock from '../../components/DescBlock'
import DragDropContainer from '../../components/DragDrop/DragDropContainer'
import { useTranslation } from 'next-i18next'

function renderHref (type) {
  if (!type) return ''
  if (type.toLowerCase() === 'audio') {
    return '/mp3-audio-editor'
  }

  if (type.toLowerCase() === 'image') {
    return '/optimizer/image-compressor'
  }

  if (type.toLowerCase() === 'document') {
    return '/pdf-manager'
  }
  if (type.toLowerCase() === 'archive') {
    return '/archive-manager'
  }
  if (type.toLowerCase() === 'video') {
    return '/video/mp4-online-converter'
  }

  return `/online-${type.toLowerCase()}-converter`
}

const FormatConverter = ({ ssrToken }) => {
  const [adsOffset, setAdsOffset] = useState(1000)
  const { isXl, isXxl } = getDeviceConfig()
  const { t } = useTranslation()
  const [cookies] = useCookies(['token'])
  const [token, setToken] = useState(ssrToken)
  const router = useRouter()
  const dispatch = useDispatch()
  const initialType = router.query.type.split('/')[0]
  const splitUrl = router.query.format.replace('-online-converter', '').split('-')
  const formatsState = useSelector(state => state.formats)
  const fileListState = useSelector(state => state.fileList.data)
  const { usage, statistic } = useSelector(state => state.fileList)
  const [fromFile, setFromFile] = useState(splitUrl[0] || '')
  const [toFile, setToFile] = useState(!splitUrl[2] ? '' : splitUrl[2] === 'to' ? splitUrl[3] : splitUrl[2] )
  const [supportedFromFormats, setSupportedFromFormats] = useState([])
  const [supportedToFormats, setSupportedToFormats] = useState([])
  const [description, setDescription] = useState([])
  const [dragdropTitle, setDragdropTitle] = useState({
    tile: 'File Converter',
    subtitle: 'Convert your files to any format'
  })
  const [type, setType] = useState(initialType.replace(/^./, initialType[0].toUpperCase()))
  const schemaData = {
    id: `${fromFile}-${toFile ? `-${toFile}-` : '-'}converter`,
    name: `${fromFile} ${toFile ? `to ${toFile}` : ''} - Free Online Software Application`,
    description: `${fromFile} ${toFile ? `to ${toFile}` : ''} converter, free convert your ${fromFile} to other formats with online software app by Evano`,
    image: [`/images/icon_${type.toLowerCase()}_converter_fag.svg`],
    ratingValue: 4.5,
    ratingCount: 1609
  }

  useEffect(() => {
    const from = splitUrl[0] || ''
    const to = !splitUrl[2] ? '' : splitUrl[2] === 'to' ? splitUrl[3] : splitUrl[2]
    setFromFile(from)
    setToFile(to)
    if (to && fileListState.length === 1) {
      const fileId = fileListState[0].id || fileListState[0].uid
      dispatch(setFormats({ ...formatsState.formats, to, fileId }))
    }
  }, [router.query.format])

  const getToDesc = async () => {
    try {
      const res = await fetchJSON(`/file-format/file-formats/${toFile}`, {
        method: 'get'
      })
      if (res.data) {
        getSupportedToFormats()
      }
      if (res.data && description.indexOf(res.data) === -1) {
        setDescription([...description, res.data])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getFromDesc = async () => {
    try {
      const res = await fetchJSON(`/file-format/file-formats/${fromFile}`, {
        method: 'get'
      })
      if (res.data) {
        getSupportedFromFormats()
      }
      if (res.data && description.indexOf(res.data) === -1) {
        setDescription([...description, res.data])
      }
    } catch (error) {
      if (error.status === 404) {
        dispatch(setList([]))
        message.error(`Format ${fromFile} is not supported`)
        router.push('/', '/')
      } else {
        console.log(error)
      }
    }
  }

  const getSupportedToFormats = async () => {
    const res = await fetchJSON(`/file-format/converted-pairs`, {
      method: 'get',
      payload: {
        target__ext: toFile,
        page_size: 500
      }
    })
    if (res.data && res.data.results) {
      const data = res.data.results
      let formatArr = []
      data.forEach(item => {
        if (item !== 'undefined') {
          formatArr.push(item.source.ext)
        }
      })
      setSupportedToFormats(formatArr)
    }
  }

  const getSupportedFromFormats = async () => {
    const res = await fetchJSON(`/file-format/converted-pairs`, {
      method: 'get',
      payload: {
        source__ext: fromFile,
        page_size: 500
      }
    })
    if (res.data && res.data.results) {
      const data = res.data.results
      let formatArr = []
      data.forEach(item => {
        formatArr.push(item.target.ext)
      })
      setSupportedFromFormats(formatArr)
    }
  }

  useEffect(() => {
    // if (fileListState.length !== 0) {
    //   const fileType = fileListState[0].type.split('/')[0]
    //   setType(fileType.replace(/^./, fileType[0].toUpperCase()))
    // }
    // (window.adsbygoogle = window.adsbygoogle || []).push({})
    const token = ssrToken || cookies.token
    setToken(token)
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleScroll = () => {
    const adsContainer = document.querySelector('div.ads_container')
    if (adsContainer) {
      const distanceScroll = document.body.scrollTop
      const elRect = adsContainer.getBoundingClientRect()
      const elOffset = elRect.top
      setAdsOffset(distanceScroll + elOffset)
    }
  }

  useEffect(() => {
    if (fromFile !== '') {
      getFromDesc()
    }
    if (toFile !== '') {
      getToDesc()
    }
    setDragdropTitle(() => {
      if (fromFile !== '' && toFile !== '') {
        return {
          title: `${fromFile.toUpperCase()} to ${toFile.toUpperCase()} Converter`,
          subtitle: `Convert your ${fromFile} files to ${toFile} online & free ${new Date().getFullYear()}`
        }
      } else if (fromFile !== '') {
        return {
          title: `${fromFile.toUpperCase()} Converter`,
          subtitle: `Convert your ${fromFile} files to any format`
        }
      }
      return {
        title: 'File Converter',
        subtitle: 'Convert your files to any format'
      }
    })
  }, [fromFile, toFile])

  useEffect(() => {
    if (formatsState.formats.from !== '') setFromFile(formatsState.formats.from)
    if (fileListState.length !== 0 && formatsState.formats.to !== '') setToFile(formatsState.formats.to)
    if (fileListState.length > 1) router.push('/', '/')
  }, [fileListState])

  useEffect(() => {
    if (formatsState.formats.to && fileListState.length === 1) {
      router.push(`/[type]/[format]`, `/${type.toLowerCase()}/${fromFile.toLowerCase()}-to-${formatsState.formats.to.toLowerCase()}-online-converter`, { shallow: true })
    }
  }, [formatsState.formats.to])

  useEffect(() => {
    dispatch(fetchUsageInfo())
    dispatch(fetchStatistics())
  }, [])

  const FormatsTable = (data) => {
    const newArr = []
    for (let i = 0; i < data.length; i += 2) {
      newArr.push([String(data[i]).toUpperCase(), String(data[i + 1]).toUpperCase()])
    }
    return newArr
  }

  const getTitle = () => {
    if (fromFile !== '' && toFile !== '') {
      return `Convert ${fromFile} to ${toFile}`
    } else if (fromFile !== '') {
      return `Convert ${fromFile}`
    }
  }

  return (
    <>
      <NextSeo
        title={`${fromFile.toUpperCase()} ${toFile ? `to ${toFile.toUpperCase()}` : ''} Converter (Online Free ${new Date().getFullYear()})`}
        description={`${fromFile.toUpperCase()} ${toFile ? `to ${toFile.toUpperCase()}` : ''} Converter, easy to use and free convert your ${fromFile.toUpperCase()} to other formats with online software. Try Evano.com now for free!`}
        canonical={`https://evano.com/${type.toLowerCase()}/${fromFile}${toFile ? '-to-' + toFile : ''}-online-converter`}
        openGraph={{
          title: `${fromFile.toUpperCase()} ${toFile ? `to ${toFile.toUpperCase()}` : ''} Converter (Online Free ${new Date().getFullYear()})`,
          url: `https://evano.com/${type.toLowerCase()}/${fromFile}${toFile ? '-to-' + toFile : ''}-online-converter`,
        }}
      />
      <Head>
        {getProductSchemes(schemaData)}
      </Head>
      <HeaderBar/>
      <DragDropContainer title={getTitle()} dragDropTitle={dragdropTitle.title}
                         dragDropSubtitle={dragdropTitle.subtitle} type="audio"/>
      <section style={{ position: 'relative' }}>
        <div className="ads_container mx-auto p-minus" style={{ position: 'relative' }}>
          <div key="v__adsbygoogle_left" className={`v__adsbygoogle left ${adsOffset < 676 ? 'fixed' : ''}`}>
            {isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{ display: 'inline-block', 'min-width': '200px', 'min-height': '50px' }}
              client="ca-pub-6022273213615485"
              slot="6680291945"
              format="auto"
              responsive={true}/>) : null}
          </div>
          <ConvertSteps fromFile={(fromFile || 'MP4').toUpperCase()}
                        toFile={(toFile || 'AVI').toUpperCase()}
                        title={`How to convert ${(fromFile || 'MP4').toUpperCase()} to ${(toFile || 'AVI').toUpperCase()}`}
                        action="Convert"/>
          <div key="v__adsbygoogle_right" className={`v__adsbygoogle right ${adsOffset < 676 ? 'fixed' : ''}`}>
            {isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{ display: 'inline-block', 'min-width': '200px', 'min-height': '50px' }}
              client="ca-pub-6022273213615485"
              slot="6680291945"
              format="auto"
              responsive={true}/>) : null}
          </div>
        </div>
      </section>
      <section className={styles.convert}>
        <div className="container">
          <Row gutter={8}>
            <Col xs={24} sm={12} className={styles.convert_from}>
              <div className={styles.convert_title}><h3>Convert&nbsp;
                <span>
                  <Link href="/formats/[type]" as={`/formats/${fromFile}`}>{fromFile}</Link>
                </span> to</h3></div>
              <div className={styles.convert_wrap}>
                {FormatsTable(supportedFromFormats).map((a) => (
                  <Row key={a[0]} className={styles.convert_row}>
                    <Col xs={12}>
                      <Link href="/[type]/[format]"
                            as={`/${initialType}/${String(fromFile)}-to-${a[0].toLowerCase()}-online-converter`}>
                        <a>
                          {String(fromFile).toUpperCase()} to {a[0]}
                        </a>
                      </Link>
                    </Col>
                    <Col xs={12}>
                      {a[1] !== 'undefined'.toUpperCase() ? <Link href="/[type]/[format]"
                                                                  as={`/${initialType}/${String(fromFile)}-to-${a[1].toLowerCase()}-online-converter`}>
                        <a>
                          {String(fromFile).toUpperCase()} to {a[1]}
                        </a>
                      </Link> : null}
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
            {toFile
              ? <Col xs={24} sm={12}>
                <div className={styles.convert_title}><h3>Convert to&nbsp;
                  <span>
                    <Link href="/formats/[type]" as={`/formats/${toFile}`}>{toFile}</Link>
                  </span></h3></div>
                <div className={styles.convert_wrap}>
                  {FormatsTable(supportedToFormats).map((a) => (
                    <Row key={a[0]} className={styles.convert_row}>
                      <Col xs={12}>
                        <Link href="/[type]/[format]"
                              as={`/${initialType}/${a[0].toLowerCase()}-to-${String(toFile)}-online-converter`}>
                          <a>
                            {a[0]} to {String(toFile).toUpperCase()}
                          </a>
                        </Link>

                      </Col>
                      <Col xs={12}>
                        {a[1] !== 'undefined'.toUpperCase() ? <Link href="/[type]/[format]"
                                                                    as={`/${initialType}/${a[1].toLowerCase()}-to-${String(toFile)}-online-converter`}>
                          <a>
                            {a[1]} to {String(toFile).toUpperCase()}
                          </a>
                        </Link> : null}
                      </Col>
                    </Row>
                  ))}
                </div>
              </Col>
              : null}
          </Row>
        </div>
      </section>

      <DescBlock data={description}/>
      <AboutBlock
        type={type}
        about={{
          title: `About ${type} Converter`,
          text: 'Convert your Documents files that were created by programs like Microsoft Word, Adobe Acrobat, LibreOffice/OpenOffice, and others. You may also be having trouble opening old files because the format is no longer supported, sometimes converting these files can fix that problem.'
        }}
        editor={{
          title: `${type} Converter`,
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut',
          icon: require('public/images/icon_audio_editor.svg')
        }}
        button={{ text: 'Try Now', href: renderHref(initialType) }}
      />
      {/* {type !== '' && <SupportedFormatTable type={type} />} */}
      <TopConversions/>

      <section className="pre_footer">
        {statistic ? <FooterArchievement totalFile={statistic.total_file}
                                         totalFileSize={statistic.total_file_size}/> : null}
      </section>

      <Footer/>
    </>

  )
}

export const getServerSideProps = async (ctx) => {
  if (ctx.params &&
    ctx.params.type &&
    ctx.params.format &&
    ctx.params.format.includes('-converter-online-software')) {
    ctx.res.writeHead(301, {
      Location: `/${ctx.params.type}/${ctx.params.format.replace('-converter-online-software', '-online-converter')}`
    })
    ctx.res.end()
  }
  const ssrToken = ctx.req.cookies.token
  if (ssrToken) {
    return {
      props: {
        ssrToken,
        ...(await serverSideTranslations(getLanguage(ctx), ['common', 'about', 'header', 'footer'])),
      }
    }
  }
  return {
    props: {
      ...(await serverSideTranslations(getLanguage(ctx), ['common', 'about', 'header', 'footer'])),
    }
  }
}

export default FormatConverter
